module.exports = __webpack_public_path__ + "media/images/emblems/Muntelier-coat_of_arms-7d263775edafc01bd8cce080e7522422.svg";